import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { Check, ShieldCheck, Truck, Lock, Gift, Star } from 'lucide-react';
import { CountdownTimer } from './ui/CountdownTimer';
import { trackAddToCart } from '../utils/metaPixel';
const IMAGES = {
  packshot: 'https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png'
};
const CHECKOUT_URLS = {
  pack1: 'http://glowliftessence.com/cart/45812197982398:1',
  pack2: 'https://glowliftessence.com/cart/45852300607678:1',
  pack3: 'http://glowliftessence.com/cart/45812198015166:1',
  pack5: 'http://glowliftessence.com/cart/45812198047934:1'
};
export function PricingSection() {
  const handlePurchaseClick = (pack: '1x' | '2x' | '3x' | '5x', price: number, url: string) => {
    trackAddToCart(`SnoreStop™ ${pack} Pack`, price);
    window.location.href = url;
  };
  return <section id="pricing" className="py-20 bg-gradient-to-b from-white to-blue-50" data-id="element-290">
      <Container data-id="element-291">
        {/* Countdown Timer */}
        <div className="mb-12 max-w-2xl mx-auto" data-id="element-292">
          <CountdownTimer data-id="element-293" />
        </div>

        <div className="text-center mb-16" data-id="element-294">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-295">
            Choose Your Bundle & <br className="hidden md:block" data-id="element-296" />
            <span className="text-blue-600" data-id="element-297">Sleep Peacefully This Week</span>
          </h2>
          <div className="inline-block bg-yellow-100 px-6 py-3 rounded-xl border border-yellow-200 shadow-sm" data-id="element-298">
            <p className="text-lg md:text-xl font-bold text-gray-900 flex items-center" data-id="element-299">
              <Star className="w-5 h-5 text-orange-500 fill-current mr-2" data-id="element-300" />
              Most customers choose the 5-Pack so they never risk going back to
              the couch again.
            </p>
          </div>
        </div>

        {/* Pricing Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto items-end" data-id="element-301">
          {/* Card 1: Starter Trial (1x) */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-6 flex flex-col items-center relative z-0 hover:border-blue-300 transition-colors" data-id="element-302">
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-303">
              Starter Trial
            </h3>
            <div className="text-gray-500 mb-4 font-medium" data-id="element-304">
              1x SnoreStop™ (1 Pack)
            </div>
            <div className="h-32 flex items-center justify-center mb-4" data-id="element-305">
              <img src={IMAGES.packshot} alt="1 Pack" className="max-h-full max-w-full object-contain" data-id="element-306" />
            </div>

            <div className="mb-6 text-center" data-id="element-307">
              <div className="text-gray-400 line-through text-lg" data-id="element-308">$79.99</div>
              <div className="text-4xl font-bold text-gray-900" data-id="element-309">$49.99</div>
              <div className="text-green-600 font-bold text-sm mt-1 bg-green-50 px-2 py-0.5 rounded" data-id="element-310">
                Save 38%
              </div>
            </div>

            <ul className="w-full space-y-3 mb-8 text-sm text-gray-600" data-id="element-311">
              <li className="flex items-center" data-id="element-312">
                <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-313" />{' '}
                1 Mouthpiece
              </li>
              <li className="flex items-center" data-id="element-314">
                <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-315" />{' '}
                Travel Case
              </li>
              <li className="flex items-center" data-id="element-316">
                <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-317" />{' '}
                Fitting Instructions
              </li>
              <li className="flex items-center font-bold text-blue-600" data-id="element-318">
                <Gift className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-319" />
                FREE Sleep Guide ($39 Value)
              </li>
              <li className="flex items-center" data-id="element-320">
                <ShieldCheck className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-321" />{' '}
                90-Day Money-Back Guarantee
              </li>
            </ul>

            <Button fullWidth variant="outline" onClick={() => handlePurchaseClick('1x', 49.99, CHECKOUT_URLS.pack1)} data-id="element-322">
              Order 1-Pack Now →
            </Button>
          </div>

          {/* Card 2: Couples Deal (2x) */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-6 flex flex-col items-center relative z-0 hover:border-blue-300 transition-colors" data-id="element-323">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-bold uppercase whitespace-nowrap shadow-md" data-id="element-324">
              Buy 1 Get 1 FREE
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-2 mt-2" data-id="element-325">
              Couples Deal
            </h3>
            <div className="text-gray-500 mb-4 font-medium" data-id="element-326">
              2x SnoreStop™ (2 Pack)
            </div>
            <div className="h-32 flex items-center justify-center mb-4" data-id="element-327">
              <div className="flex justify-center -space-x-4" data-id="element-328">
                <img src={IMAGES.packshot} alt="Pack" className="max-h-28 object-contain" data-id="element-329" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-28 object-contain" data-id="element-330" />
              </div>
            </div>

            <div className="mb-6 text-center" data-id="element-331">
              <div className="text-gray-400 line-through text-lg" data-id="element-332">$159.98</div>
              <div className="text-4xl font-bold text-gray-900" data-id="element-333">$79.99</div>
              <div className="text-green-600 font-bold text-sm mt-1 bg-green-50 px-2 py-0.5 rounded" data-id="element-334">
                Save 50%
              </div>
            </div>

            <ul className="w-full space-y-3 mb-8 text-sm text-gray-600" data-id="element-335">
              <li className="flex items-center" data-id="element-336">
                <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-337" />{' '}
                2 Mouthpieces
              </li>
              <li className="flex items-center" data-id="element-338">
                <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-339" />{' '}
                2 Travel Cases
              </li>
              <li className="flex items-center" data-id="element-340">
                <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-341" />{' '}
                Perfect for couples or backup
              </li>
              <li className="flex items-center font-bold text-blue-600" data-id="element-342">
                <Gift className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-343" />
                FREE Sleep Guide ($39 Value)
              </li>
              <li className="flex items-center" data-id="element-344">
                <ShieldCheck className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-345" />{' '}
                90-Day Guarantee
              </li>
            </ul>

            <Button fullWidth variant="outline" onClick={() => handlePurchaseClick('2x', 79.99, CHECKOUT_URLS.pack2)} data-id="element-346">
              Order 2-Pack Now →
            </Button>
          </div>

          {/* Card 3: Most Popular (3x) - HIGHLIGHTED */}
          <div className="bg-white rounded-2xl shadow-2xl border-2 border-blue-600 p-8 flex flex-col items-center relative z-10 transform lg:-translate-y-4" data-id="element-347">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-600 text-white px-4 py-2 rounded-full font-bold uppercase tracking-wider shadow-lg whitespace-nowrap text-xs md:text-sm text-center" data-id="element-348">
              ⭐ Most Popular — Buy 2 Get 1 FREE
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2 mt-4" data-id="element-349">
              Most Popular
            </h3>
            <div className="text-gray-500 mb-4 font-medium" data-id="element-350">
              3x SnoreStop™ (3 Pack)
            </div>

            <div className="h-36 flex items-center justify-center mb-4" data-id="element-351">
              <div className="flex justify-center -space-x-4" data-id="element-352">
                <img src={IMAGES.packshot} alt="Pack" className="max-h-32 object-contain" data-id="element-353" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-32 object-contain" data-id="element-354" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-32 object-contain" data-id="element-355" />
              </div>
            </div>

            <div className="mb-6 text-center" data-id="element-356">
              <div className="text-gray-400 line-through text-xl" data-id="element-357">$239.97</div>
              <div className="text-5xl font-bold text-gray-900" data-id="element-358">$109.99</div>
              <div className="text-green-600 font-bold text-sm mt-1 bg-green-100 px-3 py-1 rounded-full" data-id="element-359">
                Save 54%
              </div>
            </div>

            <ul className="w-full space-y-3 mb-8 text-gray-700" data-id="element-360">
              <li className="flex items-center font-semibold" data-id="element-361">
                <Check className="w-5 h-5 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-362" />{' '}
                Best for long-term results
              </li>
              <li className="flex items-center font-bold text-blue-600" data-id="element-363">
                <Gift className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0" data-id="element-364" />
                FREE Sleep Guide ($39 Value)
              </li>
              <li className="flex items-center" data-id="element-365">
                <ShieldCheck className="w-5 h-5 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-366" />{' '}
                90-Day Guarantee
              </li>
            </ul>

            <Button fullWidth variant="primary" size="lg" className="animate-pulse shadow-xl shadow-blue-900/30" onClick={() => handlePurchaseClick('3x', 109.99, CHECKOUT_URLS.pack3)} data-id="element-367">
              Order 3-Pack Now →
            </Button>
          </div>

          {/* Card 4: Best Value (5x) */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-6 flex flex-col items-center relative z-0 hover:border-blue-300 transition-colors" data-id="element-368">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gray-800 text-white px-3 py-1 rounded-full text-xs font-bold uppercase whitespace-nowrap shadow-md" data-id="element-369">
              ⭐ Best Value — Buy 3 Get 2 FREE
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-2 mt-2" data-id="element-370">
              Best Value
            </h3>
            <div className="text-gray-500 mb-4 font-medium" data-id="element-371">
              5x SnoreStop™ (5 Pack)
            </div>

            <div className="h-32 flex items-center justify-center mb-4" data-id="element-372">
              <div className="flex justify-center -space-x-6" data-id="element-373">
                <img src={IMAGES.packshot} alt="Pack" className="max-h-24 object-contain" data-id="element-374" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-24 object-contain" data-id="element-375" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-24 object-contain" data-id="element-376" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-24 object-contain" data-id="element-377" />
                <img src={IMAGES.packshot} alt="Pack" className="max-h-24 object-contain" data-id="element-378" />
              </div>
            </div>

            <div className="mb-6 text-center" data-id="element-379">
              <div className="text-gray-400 line-through text-lg" data-id="element-380">$399.95</div>
              <div className="text-4xl font-bold text-gray-900" data-id="element-381">$159.99</div>
              <div className="text-green-600 font-bold text-sm mt-1 bg-green-50 px-2 py-0.5 rounded" data-id="element-382">
                Save 60%
              </div>
            </div>

            <ul className="w-full space-y-3 mb-8 text-sm text-gray-600" data-id="element-383">
              <li className="flex items-center" data-id="element-384">
                <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-385" />{' '}
                Never run out again
              </li>
              <li className="flex items-center" data-id="element-386">
                <Check className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-387" />{' '}
                Share with family
              </li>
              <li className="flex items-center font-bold text-blue-600" data-id="element-388">
                <Gift className="w-4 h-4 text-blue-600 mr-2 flex-shrink-0" data-id="element-389" />
                FREE Sleep Guide ($39 Value)
              </li>
              <li className="flex items-center" data-id="element-390">
                <ShieldCheck className="w-4 h-4 text-green-500 mr-2 flex-shrink-0 stroke-[3px]" data-id="element-391" />{' '}
                90-Day Guarantee
              </li>
            </ul>

            <Button fullWidth variant="outline" onClick={() => handlePurchaseClick('5x', 159.99, CHECKOUT_URLS.pack5)} data-id="element-392">
              Order 5-Pack Now →
            </Button>
          </div>
        </div>

        {/* Urgency & Trust */}
        <div className="mt-16 text-center space-y-6 bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-393">
          <h3 className="text-2xl font-bold text-red-600 uppercase tracking-wide flex items-center justify-center" data-id="element-394">
            <span className="w-2 h-2 bg-red-600 rounded-full mr-3 animate-pulse" data-id="element-395"></span>
            Limited Daily Stock Warning
          </h3>

          <p className="text-gray-700 text-lg max-w-2xl mx-auto" data-id="element-396">
            Due to high demand and small-batch production, we can only ship a
            limited number of SnoreStop™ units per day.
          </p>

          <p className="text-blue-900 font-bold text-xl" data-id="element-397">
            Order now to start sleeping together again this week.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-gray-500 text-sm pt-4 border-t border-gray-200 mt-6" data-id="element-398">
            <span className="flex items-center font-medium" data-id="element-399">
              <Lock className="w-4 h-4 mr-2 text-green-600" data-id="element-400" /> Secure Checkout
            </span>
            <span className="flex items-center font-medium" data-id="element-401">
              <ShieldCheck className="w-4 h-4 mr-2 text-green-600" data-id="element-402" /> 90-Day
              Guarantee
            </span>
            <span className="flex items-center font-medium" data-id="element-403">
              <Truck className="w-4 h-4 mr-2 text-green-600" data-id="element-404" /> Fast Shipping
            </span>
          </div>
        </div>
      </Container>
    </section>;
}